import { ITEM_TYPES } from "../item/item-types";

export class Collection {
    public title: string;
    public titleDe: string;
    public titleFa: string;
    public name: string;
    public type: ITEM_TYPES;
    public itemType : string;
    public content: Object;
    public cost: Number;
    public description: string;
    public descriptionDe: string;
    public descriptionFa: string;
    public subItems : Array<Collection>;
    public lang : string | undefined;
    public localCount : number = 0;
    public static typeDictionary = ITEM_TYPES.Dictionary;
    public static typeLeitner = ITEM_TYPES.Leitner;
    public static typeQuiz = ITEM_TYPES.Quiz;
    constructor(collection:any, lang?: string){
        this.subItems =[];
        var self = this;
        if(collection.cloud == true ) {
     
            this.title = collection.collectionTitle;
            this.titleDe = collection.collectionTitleDe;
            this.titleFa = collection.collectionTitleFa;
            this.name = collection.collectionName;
            this.type = collection.collectionType;
            this.cost = collection.collectionPrice;
            this.description = collection.collectionDescription;
            this.descriptionDe = collection.collectionDescriptionDe;
            this.descriptionFa = collection.collectionDescriptionFa;
            this.lang = lang;
//            this.logger.debug("content true",collection);
//            this.content = JSON.parse(collection.content);
            if(collection.collectionSubItems !== undefined )
                Object.keys(collection.collectionSubItems).forEach(function(key){
    //                if(collection['subItems'][key] !== undefined || collection['subItems'][key] !== null )
                        collection['collectionSubItems'][key].cloud = true;

                        self.subItems.push(new Collection(collection['collectionSubItems'][key], lang));
                });
        }
        else {
            this.title = collection['title'];
            this.titleDe = collection['titleDe'];
            this.titleFa = collection['titleFa'];
            this.name = collection['name'];
            this.type = collection['type'];
            this.cost = collection['cost'];
            this.description = collection['description'];
            this.descriptionDe = collection['descriptionDe'];
            this.descriptionFa = collection['descriptionFa'];
            if(lang)
                this.lang = lang;
            this.lang = collection['lang'];
//            this.logger.debug("content ",collection['content']);
           
//            if (Tools.CHECK.isJson(collection['content']))
//                this.content = JSON.parse(collection['content']);
//            this.logger.debug("content=>",collection['content']);
//            ;
//            this.content = JSON.parse(collection['content']);

            if(collection['subItems'] !== undefined )
                Object.keys(collection['subItems']).forEach(function(key){
    //                if(collection['subItems'][key] !== undefined || collection['subItems'][key] !== null )
                        self.subItems.push(new Collection(collection['subItems'][key]));
                });
        }
        this.localCount = 1;
    }
    getTitle(){
        let title : string;
        switch(this.lang){
            case "de":
                title = this.titleDe;
            break;
            case "fa":
                title = this.titleFa;
            break;
            case "en":
                title = this.title;
            break;
            default : 
                title = this.titleFa;
            break;
        }
       return title;
    }
    setLang(lang : any){
        this.lang = lang; 
    }
    getDescription(){
        let lang = this.lang;
        // this.logger.debug("resmsg", "lang in collection", this.lang);
        let description : string ="";
        switch(this.lang){
            case "de":
                description = this.descriptionDe;
            break;
            case "fa":
                // this.logger.debug("resmsg","im persian description", this.descriptionFa);
                description = this.descriptionFa
            break;
            case "en":
                // this.logger.debug("resmsg","im english description", this.description);
                description = this.description;
            break;
        }
       return description;
    }
    isDictionary(){
        return this.type == "dictionary";
    }
}